module.exports = __webpack_public_path__ + "img/HU.ed612b17.svg";